import Collapse from './Collapse';

const Anim = {
  Collapse,
};

export default Anim;
